import {
  COUNTRIES_WITH_STATE_FIELD,
  COUNTRY_AUSTRALIA,
  COUNTRY_AUSTRALIA_CODE,
  COUNTRY_CANADA,
  COUNTRY_CANADA_CODE,
  COUNTRY_US,
  COUNTRY_US_CODE,
  STATES_AUSTRALIA,
  STATES_CANADA,
  STATES_US,
  STRIPE_VALIDATED_COUNTRIES,
} from "@common/constants/data";
import { SelectItem } from "@mantine/core";

export function isAddressValidated(country: string): boolean {
  return STRIPE_VALIDATED_COUNTRIES.includes(country);
}

export function isStateFieldNeeded(country: string): boolean {
  return COUNTRIES_WITH_STATE_FIELD.includes(country);
}

export function getSelectItemsFromCountry(country: string): SelectItem[] {
  // US
  if (country === COUNTRY_US || country === COUNTRY_US_CODE) {
    return STATES_US;
  }
  // Canada
  else if (country === COUNTRY_CANADA || country === COUNTRY_CANADA_CODE) {
    return STATES_CANADA;
  }
  // Australia
  else if (
    country === COUNTRY_AUSTRALIA ||
    country === COUNTRY_AUSTRALIA_CODE
  ) {
    return STATES_AUSTRALIA;
  }

  // else
  return [{ value: "n/a", label: `${country} is not supported` }];
}
